
import sortTabsAutocomplete from './sort';

// tabs = [{
// 	label,
// 	id, // country id
// 	... // any data
// 	tree: [{
// 		label,
// 		... // any data
// 		children,
// 	}],
// }]

const getRegionsTabsAutocomplete = geoData => {
	const countriesMap = {}
	geoData.regions.forEach(region => {
		if (region.id === '' || region.id == null) return;
		if(!countriesMap[region.countryId]){
			const country = geoData.countries?.find(({id}) => id === region.countryId);
			if (!country) return;
			countriesMap[country.id] = {
				label: country.label,
				id: country.id,
				tree: [],
			}
		}
		countriesMap[region.countryId].tree.push({
			label: region.label,
			id: region.id,
		});
	});
	const countries = Object.values(countriesMap);
	sortTabsAutocomplete(countries, {tabsFirstFR: true});
	return countries;
}
export default getRegionsTabsAutocomplete;